module.exports = __webpack_public_path__ + "img/video.8bda7066.png";